module.exports = __webpack_public_path__ + "img/dongji_ps_15.425d797e.jpg";